import { PaletteColor, Theme, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
// Import to ensure theme augmentation is loaded
import "@teamworksdev/mui";

//
// This is a copy of apps/web/src/pages/Theme/AppTheme.tsx so that libs/shared/ui code can get the Nutrition specific extra colors
//

const getMacros = (theme: Theme) => {
  const {
    palette: {
      accents: { green, blueDark, orangeDark },
    },
  } = theme;

  const cho: PaletteColor = {
    lighter: green[50],
    light: green[100],
    main: green[700],
    dark: green[900],
    contrastText: "#fff",
  };

  const pro: PaletteColor = {
    lighter: blueDark[50],
    light: blueDark[100],
    main: blueDark[700],
    dark: blueDark[900],
    contrastText: "#fff",
  };

  const fat: PaletteColor = {
    lighter: orangeDark[50],
    light: orangeDark[100],
    main: orangeDark[700],
    dark: orangeDark[900],
    contrastText: "#fff",
  };

  return { cho, pro, fat };
};

const getLikeDislike = (theme: Theme) => {
  const {
    palette: { success, error },
  } = theme;

  const like = success;
  const dislike = error;

  return { like, dislike };
};

export const performance = {
  primary: "#0A8560",
  secondary: "#B6DACF",
  tertiary: "#E7F3EF",
};

export type AppTheme = Theme & {
  palette: Theme["palette"] & {
    performance: typeof performance;
    cho: PaletteColor;
    pro: PaletteColor;
    fat: PaletteColor;
    like: PaletteColor;
    dislike: PaletteColor;
    teamworksCalendarEvent: string;
    rpeLight: PaletteColor;
    rpeModerate: PaletteColor;
    rpeHeavy: PaletteColor;
    orderStatusNew: PaletteColor;
    orderStatusCooking: PaletteColor;
    orderStatusDone: PaletteColor;
    orderStatusCancelled: PaletteColor;
  };
};

export const useAppTheme = (): AppTheme => {
  const sharedTheme = useTheme();
  const {
    palette: { grey, success, warning, info, error },
  } = sharedTheme;
  const teamworksCalendarEvent = grey[300];
  const rpeLight = success;
  const rpeModerate = warning;
  const rpeHeavy = error;
  const orderStatusNew = info;
  const orderStatusCooking = warning;
  const orderStatusDone = success;
  const orderStatusCancelled = error;

  const { cho, pro, fat } = getMacros(sharedTheme);
  const { like, dislike } = getLikeDislike(sharedTheme);
  const theme: AppTheme = {
    ...sharedTheme,
    palette: {
      ...sharedTheme.palette,
      performance,
      cho,
      pro,
      fat,
      like,
      dislike,
      teamworksCalendarEvent,
      rpeLight,
      rpeModerate,
      rpeHeavy,
      orderStatusNew,
      orderStatusCooking,
      orderStatusDone,
      orderStatusCancelled,
    },
  };

  return theme;
};

export const makeAppStyles = <T extends string | number | symbol>(styles: (theme: AppTheme) => Record<T, any>) => {
  return makeStyles(() => {
    const appTheme = useAppTheme();
    return styles(appTheme);
  });
};
